/**
 * Cloud de Cloudinary del proyecto.
 *
 * `NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME` se inlinea en build, así que cualquier
 * entorno que no la defina (local sin .env, un preview mal configurado, un CI)
 * generaba URLs `https://res.cloudinary.com/undefined/...`. Eso rompía en
 * silencio todas las imágenes del sitio, logos incluidos, sin error visible.
 *
 * El fallback apunta al cloud real del proyecto, así que las imágenes se ven
 * siempre; la variable sigue mandando cuando existe.
 */
export const CLOUDINARY_CLOUD =
  process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME || "dnrrghxph";

/** Base de las URLs de Cloudinary: `https://res.cloudinary.com/<cloud>`. */
export const CLOUDINARY_BASE = `https://res.cloudinary.com/${CLOUDINARY_CLOUD}`;
